export const ClvrPrscTitlePrimaryColor = '#1D4F7E'
